import { TextField, MenuItem } from "@mui/material"
import { useState, useEffect } from "react"
import API from "../../services/API";

export default function Variant({value, onChange, required, disabled}){

    const [types, setTypes] = useState([]);

    useEffect(() => {

        API.get(`/product/variants`)
            .then(r => setTypes(Array.isArray(r.data) ? r.data : []))
            .catch(e => console.log(e))

    }, [])

    const handleChange = e => {
        const val = types.find(t => t.id === e.target.value)
        return onChange(val);
    }

    return <TextField
        label='Variant'
        select
        size='small'
        value={types.length > 0 ? (value?.id || '') : ''}
        onChange={handleChange}
        fullWidth
        required={required ? true : false}
        disabled={disabled}
    >
        {!required && <MenuItem value='all'>Tous</MenuItem>}
        {types.map(t => 
            <MenuItem key={t.id} value={t.id}>{t.title}</MenuItem>    
        )}
    </TextField>
}